module.exports = __webpack_public_path__ + "static/media/loc3_img6.4119a140.jpg";